import React from 'react';
import ReactJson from 'react-json-view';
import CircularProgress from '@material-ui/core/CircularProgress';

import Dialog from 'routes/Dashboard/Template/components/Dialog';

class PushApiLog extends React.Component {
  renderContent() {
    const { pushEvent, collapse } = this.props;

    return pushEvent ? (
      <div style={{ minWidth: 400, minHeight: 200 }}>
        <ReactJson
          src={pushEvent}
          enableClipboard={true}
          displayObjectSize={false}
          displayDataTypes={false}
          sortKeys={false}
          collapsed={collapse !== false}
        />
      </div>
    ) : (
      <div
        style={{
          minWidth: 400,
          minHeight: 200,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  render() {
    const { api, onClose } = this.props;

    return (
      <Dialog
        title={api ? api.name : ''}
        content={this.renderContent()}
        open={Boolean(api)}
        onClose={onClose}
        props={{ fullWidth: true, disableEnforceFocus: true }}
      />
    );
  }
}

export default PushApiLog;
